import React, { FC, ReactNode } from 'react';
import { styled } from '@cp/ds/src/theme/styled';
import { Box, BoxProps } from '@cp/ds/src/components/box';
import { SxProps } from '@cp/ds';
import PlaceholderUrl from '../../../assets/shapes/map.svg?url';
import PinsUrl from '../../../assets/shapes/pin.svg?url';

const StyledBox = styled(Box)({
  position: 'relative',
  width: '100%',
  height: '100%',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundImage: `url(${PlaceholderUrl})`,
  backgroundPosition: 'center center',
});

const PinsOverlay = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundImage: `url(${PinsUrl})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
  opacity: 0,
  animation: 'fadeIn 2s ease forwards',
  animationDelay: '1s',
  zIndex: 2,

  '@keyframes fadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
});

const BlurOverlay = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backdropFilter: 'blur(2px)',
  backgroundColor: 'rgba(255, 255, 255, 0.3)',
  zIndex: 3,
  transition: 'all 0.3s ease',
});

export interface MapPlaceholderProps extends BoxProps {
  children?: ReactNode;
}
interface WithPinsOptions {
  pinsSx?: SxProps;
  blurSx?: SxProps;
}

export const MapPlaceholder = (props: MapPlaceholderProps) => <StyledBox {...props} />;

export const MapPlaceholderWithPins = <T extends MapPlaceholderProps>(
  Component: FC<T>,
  { pinsSx, blurSx }: WithPinsOptions = {},
): FC<T> => {
  return (props: T) => (
    <Component {...props}>
      <PinsOverlay sx={pinsSx} />
      <BlurOverlay sx={blurSx} />
      {props.children}
    </Component>
  );
};
